(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name DelegadosController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('DelegadosController', DelegadosController);

    DelegadosController.$inject = ["DelegadosService","$timeout","$location",'$anchorScroll'];

    function DelegadosController(DelegadosService,$timeout,$location,$anchorScroll)
    {
    	var vm = this;
        console.log("del");
        vm.provincia = "";
        vm.categoria_id = "";
        vm.loading = false;
        vm.getDelegados = function(){
            vm.loading = true;
            DelegadosService.getDelegados(vm.categoria_id,vm.provincia,function(data){
                vm.loading = false;
                //console.log(data);
                vm.delegados = data.delegados;
                vm.currentZona = data.zona;
            },function(){vm.loading = false;});
        };

        vm.getDelegadosByZona = function(zona){
            vm.currentZona = zona;
            DelegadosService.getDelegadosByZona(vm.categoria_id,vm.currentZona,function(data){
                //console.log(data);
                vm.delegados = data.delegados;
                vm.currentZona = data.zona;
                vm.provincia = data.zona.id;
            });
        };
    }


})();